import $ from 'jquery';

export function initInfiniteScroll() {
  // let newsStoryNumber =1;
  const scrollSelector = window;
  if ($('#infinite-next-link').length > 0) {
    const nextSelector = $('#infinite-next-link');

    $(scrollSelector).bind('scroll', function() {
      infiniteScroll(nextSelector);
    });
  }

  function infiniteScroll(nextSelector) {
    const currentY = $(window).height() + window.scrollY;
    const triggerPoint = $('#infinite-next-link').offset().top;
    if (currentY > triggerPoint) {
      $(scrollSelector).unbind('scroll');
      const href = $(nextSelector).attr('href');
      let route = $(nextSelector).attr('data-page-route');
      if (route.substr(-1, 1) !== '/');
      {
        route += '/';
      }

      const pg = parseInt(href.replace(route, ''));
      $.get(href, function(data) {
        $('.newsList').append(data);
        const totalPages = 0 + $(nextSelector).attr('data-page-count');
        if (pg < totalPages) {
          $(nextSelector).attr('href', href.replace(pg, pg + 1));
          $(scrollSelector).bind('scroll', function() {
            infiniteScroll(nextSelector);
          });
        }
      });
    }
  }
}
